import React from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex h-screen bg-gray-50 overflow-hidden" data-id="element-80">
      <Sidebar data-id="element-81" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-82">
        <Header data-id="element-83" />
        <main className="flex-1 overflow-y-auto p-6" data-id="element-84">
          <div className="max-w-7xl mx-auto" data-id="element-85">{children}</div>
        </main>
      </div>
    </div>;
}